/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import allPixelPals from "../../assets/images/all-pixelpals.png";
import pixelPalsOverview from "../../assets/images/pixelpals-overview.jpg";
import "../../styles/singleProjects.css";
import CodeEditorMock from "../Panels/CodeEditorMock";
import allPixelPals2 from "../../assets/images/ducks-cats.png";

const PixelPals = () => {
  return (
    <div className="biopanel single-project-panel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          pixelPals
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          <CodeEditorMock>
            This is a{" "}
            <span class="function-color op-1">
              web-based pixel pet game project of mine{" "}
            </span>{" "}
            where users can <span class="string-color-text op-1">buy</span>,{" "}
            <span class="string-color-text op-1">sell</span>, and{" "}
            <span class="string-color-text op-1">trade animals</span> using{" "}
            <span class="string-color-text op-1">in-game currency only</span>
            , real money is never involved.
            <br />
            <br />
            Each pixel animal is powered by its own logic. They behave
            independently: getting{" "}
            <span class="string-color-text op-1">hungry</span>,{" "}
            <span class="string-color-text op-1">sleepy</span>, and sometimes{" "}
            <span class="string-color-text op-1">interacting</span> with others
            whether it’s a <span class="html-color-text op-1">fight</span> or a{" "}
            <span class="return-color op-1">friendly moment</span>. These are
            all <span class="docker-color-text op-1">random encounters</span>{" "}
            driven by backend logic.
            <br />
            <br />
            When tired, they’ll sleep until their energy is restored. When
            hungry, they’ll get mad and demand food with an angry{" "}
            <span class="html-color-text op-1">"!!!"</span>. Every interaction,
            from sleep cycles to moods and activities, is{" "}
            <span class="string-color-text op-1">saved to the database</span>{" "}
            and handled <span className="js-color-text">server-side.</span>
            <br />
            <br />I used <span class="react-color-text op-1">React</span>,{" "}
            <span class="nodejs-color-text op-1">Node.js</span>,{" "}
            <span class="nodejs-color-text op-1">Express</span>,{" "}
            <span class="mongo-color-text op-1">MongoDB</span>, and{" "}
            <span class="nodejs-color-text op-1">WebSocket</span> to make
            real-time interactions feel dynamic and alive.
          </CodeEditorMock>
        </div>
        <div className="right">
          <p className="comment">// Pixel pals (alpha version)</p>
          <img src={allPixelPals} alt="pixelpals" />
          <img className="pixel-img-3" src={allPixelPals2} alt="pixelpals" />
          <p className="comment">
            // This is the dashboard, gamearea (photo taken when frontend was on
            development)
          </p>
          <img src={pixelPalsOverview} alt="pixelpals" />

          <p className="comment">// Some initial codes on alpha phase</p>
          <div className="box-container">
            <CodeEditorMock>
              <span class="const-color">const</span>{" "}
              <span class="function-color">resetAllPals</span> ={" "}
              <span class="const-color">async</span> (
              <span class="variable-color">req</span>,{" "}
              <span class="variable-color">res</span>) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">try</span> {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">
                const
              </span>{" "}
              <span class="variable-color">allPals</span> ={" "}
              <span class="function-color">await</span>{" "}
              <span class="function-color">Pal.find()</span>;
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">for</span> (
              <span class="const-color">const</span>{" "}
              <span class="variable-color">pal</span> of{" "}
              <span class="variable-color">allPals</span>) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">await Pal.findByIdAndUpdate</span>(
              <span class="variable-color">pal._id</span>, {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">isSleeping</span>:{" "}
              <span class="true-color-text">false</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">energy</span>:{" "}
              <span class="string-color-text">1000</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">encounter</span>:{" "}
              <span class="true-color-text">false</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">isStopped</span>:{" "}
              <span class="true-color-text">false</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"}"}, {"{ new: "}
              <span class="true-color-text">true</span>
              {" }"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="return-color">res.status</span>(
              <span class="string-color-text">200</span>).
              <span class="return-color">json</span>({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">success</span>:{" "}
              <span class="true-color-text">true</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">message</span>:{" "}
              <span class="string-color-text">
                "All pals has been reseted."
              </span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;{"}"} <span class="const-color">catch</span> (
              <span class="variable-color">err</span>) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="return-color">res.status</span>(
              <span class="string-color-text">500</span>).
              <span class="return-color">json</span>
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              {"}"};
              <br />
              <br />
              <span class="const-color">const</span>{" "}
              <span class="function-color">feedOnePal</span> ={" "}
              <span class="const-color">async</span> (
              <span class="variable-color">req</span>,{" "}
              <span class="variable-color">res</span>) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span> {"{ "}
              <span class="variable-color">id</span> {"}"} ={" "}
              <span class="variable-color">req.params</span>;
              <br />
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span>{" "}
              <span class="variable-color">pal</span> ={" "}
              <span class="function-color">await Pal.findById</span>(
              <span class="variable-color">id</span>);
              <br />
              <br />
              &nbsp;&nbsp;<span class="const-color">if</span> (
              <span class="variable-color">pal</span>) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">await Pal.findByIdAndUpdate</span>(
              <span class="variable-color">id</span>, {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">hunger</span>:{" "}
              <span class="function-color">Math.min</span>(
              <span class="variable-color">pal.hunger</span> +{" "}
              <span class="string-color-text">500</span>,{" "}
              <span class="string-color-text">1000</span>)
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="return-color">res.status</span>(
              <span class="string-color-text">200</span>).
              <span class="return-color">json</span>
              <br />
              &nbsp;&nbsp;{"}"} <span class="const-color">else</span> {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">console.log</span>(
              <span class="string-color-text">"Pal not found"</span>);
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              {"}"};
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PixelPals;
